export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10548.6675ae0c.jpg";